// extracted by mini-css-extract-plugin
module.exports =  {"legendPriceRoot":"LegendLivePrice-module__legendPriceRoot--Vn_Fg","priceContainer":"LegendLivePrice-module__priceContainer--wqaBO"};